<template>
	<span :class="['gems',type]">{{gems}}</span>
</template>
<script>
export default{
    name: "Gems",
    props:{
        gems: Number,
        type: String
    },
	data(){
		return{}
	},
	inheritAttrs: false
}
</script>
<style lang="scss" scoped>
.gems{
    @include flexrc;
    color: #ffd65f;
    @include res-size(
        $font-size: 30px
    )
    &::before{
        display: block;
        content: '';
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url(https://freefiremobile-a.akamaihd.net/common/web_event/common/images/diamond.png);
        @include res-size(
            $width: 27px,
            $height: 23px,
            $margin-right: 3px
        )
    }
}
.gems.origin-gems{
    color: #5da5ab;
    @include res-size(
        $font-size: 22px
    )
    &::before{
        @include res-size(
            $width: 23px,
			$height: 20px
        )
    }
}

</style>


// WEBPACK FOOTER //
// src/components/gems/index.vue